import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBmCB1DraznTlq_tpkXJj_DB8g4_zS_a3E",
        language:'en',
        libraries: 'places'
    },
});



// WEBPACK FOOTER //
// ./src/plugins/google_maps.js